import React from 'react';
import ProjectOverview from '../pages/Project_overview';
import bd from '../images/bd.png';
import camera from '../images/camera.png';
import sd2 from '../images/sd2.jpg';
import '../css/SystemArchitecture.css'; 

const SystemArchitecture = () => {
  return (
    <div className="system-architecture-container">
      <ProjectOverview />
      <h1 className="system-architecture-heading">System Architecture(D1)</h1>

      <img className="architecture-image" src={bd} alt="Image 1" />
     <br/>
     <br/>
     <br/>
     

     <h1 className="system-architecture-heading">System Architecture(D2)</h1>

      <img className="architecture-image" src={sd2} alt="Image 1" />
     <br/>
     <br/>
     <br/>
     

      <h1 className="system-architecture-heading">Connection Diagram between Arduino And Camera</h1>
      <img className="architecture-image" src={camera} alt="Image 2" />
      <br/>
     <br/>
     <br/>
    </div>
  );
};

export default SystemArchitecture;
